import { useMemo } from 'react';

import { useEndpoint } from 'api';
import StorePopover from 'components/StorePopover';
import {
	type StoreIdName,
	useGlobalPopoversContext,
	useSelectedStore,
} from 'contexts';
import { useI18n } from 'utils/i18n';

/** Popover for the global product card store selector */
export default function GlobalStockStoreSelectorPopover() {
	const { t } = useI18n();
	const { closeStoreSelector, isStoreSelectorOpen, storeSelectorProductId } =
		useGlobalPopoversContext();
	const { selectedStore, updateSelectedStore } = useSelectedStore();

	const onStoreSelect = (store: StoreIdName) => {
		updateSelectedStore(store);
		closeStoreSelector();
	};

	const { data: storesStockData, isLoading: isLoadingStoresStock } =
		useEndpoint(
			storeSelectorProductId
				? {
						name: 'GetVariantStockStores',
						pathParams: { variantId: storeSelectorProductId },
						queryParams: { storeSorting: 'Alphabetical' },
					}
				: null,
		);

	const allStores = useMemo(
		() =>
			storesStockData?.map((storeStock) => ({
				...storeStock,
				id: storeStock.storeId,
				name: storeStock.storeName,
			})),
		[storesStockData],
	);

	if (selectedStore) {
		return null;
	}

	return (
		<StorePopover
			baseId="global-stock-store"
			title={t('store_stock_popover_select_store_title')}
			isLoading={isLoadingStoresStock}
			isOpen={isStoreSelectorOpen}
			onClose={() => {
				closeStoreSelector();
			}}
			onStoreSelectClick={(store) => {
				onStoreSelect({ id: store.id, name: store.name });
			}}
			allStores={allStores}
		/>
	);
}
GlobalStockStoreSelectorPopover.displayName = 'GlobalStoreSelectorPopover';
